module.exports = __webpack_public_path__ + "static/media/roche azul.cb1f1e92.png";